/* tslint:disable */
/* eslint-disable */
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CreatePaymentMethodSetupSessionData
 */
export interface CreatePaymentMethodSetupSessionData {
    /**
     * 
     * @type {string}
     * @memberof CreatePaymentMethodSetupSessionData
     */
    successPath: string;
    /**
     * 
     * @type {string}
     * @memberof CreatePaymentMethodSetupSessionData
     */
    cancelPath: string;
}

/**
 * Check if a given object implements the CreatePaymentMethodSetupSessionData interface.
 */
export function instanceOfCreatePaymentMethodSetupSessionData(value: object): value is CreatePaymentMethodSetupSessionData {
    if (!('successPath' in value) || value['successPath'] === undefined) return false;
    if (!('cancelPath' in value) || value['cancelPath'] === undefined) return false;
    return true;
}

export function CreatePaymentMethodSetupSessionDataFromJSON(json: any): CreatePaymentMethodSetupSessionData {
    return CreatePaymentMethodSetupSessionDataFromJSONTyped(json, false);
}

export function CreatePaymentMethodSetupSessionDataFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreatePaymentMethodSetupSessionData {
    if (json == null) {
        return json;
    }
    return {
        
        'successPath': json['successPath'],
        'cancelPath': json['cancelPath'],
    };
}

  export function CreatePaymentMethodSetupSessionDataToJSON(json: any): CreatePaymentMethodSetupSessionData {
      return CreatePaymentMethodSetupSessionDataToJSONTyped(json, false);
  }

  export function CreatePaymentMethodSetupSessionDataToJSONTyped(value?: CreatePaymentMethodSetupSessionData | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'successPath': value['successPath'],
        'cancelPath': value['cancelPath'],
    };
}

